/* unplugin-vue-components disabled */import { render } from "./slider.vue?vue&type=template&id=6f67ce91"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f67ce91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f67ce91', __exports__)) {
    api.reload('6f67ce91', __exports__)
  }
  
  module.hot.accept("./slider.vue?vue&type=template&id=6f67ce91", () => {
    api.rerender('6f67ce91', render)
  })

}


export default __exports__